
    const data = {"name":"src/core/icons/alert-circle-outline","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M11 15h2v2h-2v-2m0-8h2v6h-2V7m1-5C6.47 2 2 6.5 2 12a10 10 0 0 0 10 10 10 10 0 0 0 10-10A10 10 0 0 0 12 2m0 18a8 8 0 0 1-8-8 8 8 0 0 1 8-8 8 8 0 0 1 8 8 8 8 0 0 1-8 8Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            